export default __webpack_public_path__ + "8ccc7708adc370d6365aa5558ee39a62.svg";